/* eslint-disable import/no-cycle */
import adminInstructionSaga from '@/admin/pages/instruction/Sagas';
import profileSagas from '@/admin/pages/profile/Sagas';
import adminPlaylistSaga from '@/admin/pages/quiz/Sagas';
import episodeSagas from '@/admin/pages/studyGoBridgeEpisodes/Sagas';
import episodeDetailsSagas from '@/admin/pages/studyGoEpisodeDetails/Sagas';
import roomDetailsSagas from '@/admin/pages/studyGoRoomDetails/Sagas';
import subjectDetailsSaga from '@/admin/pages/subjectDetails/Sagas';
import subjectsSaga from '@/admin/pages/subjects/Sagas';
import topicsSaga from '@/admin/pages/topics/Sagas';

import manageCategorySaga from '@/admin/components/modals/manageCategory/Sagas';
import manageDifficultySaga from '@/admin/components/modals/manageDifficulty/Sagas';
import manageEpisodeSagas from '@/admin/components/modals/manageEpisodeModal/Sagas';
import managePlaylistSaga from '@/admin/components/modals/managePlaylist/Sagas';
import manageSubcategorySaga from '@/admin/components/modals/manageSubcategory/Sagas';
import manageSubjectSaga from '@/admin/components/modals/manageSubject/Sagas';
import manageTopicSaga from '@/admin/components/modals/manageTopic/Sagas';
import addWysiwygImageModalSaga from '@/admin/components/wysiwyg/addImage/Sagas';

const rootAdminSaga = () => [
	addWysiwygImageModalSaga,
	adminPlaylistSaga,
	adminInstructionSaga,

	profileSagas,
	subjectsSaga,
	subjectDetailsSaga,
	topicsSaga,
	episodeSagas,
	episodeDetailsSagas,
	roomDetailsSagas,

	manageSubjectSaga,
	manageCategorySaga,
	manageSubcategorySaga,
	manageTopicSaga,
	manageEpisodeSagas,
	managePlaylistSaga,
	manageDifficultySaga,
];

export default rootAdminSaga;
